export default __webpack_public_path__ + "static/media/ecovole-logo.c4576fcf.webp";